import { ApolloError, ApolloQueryResult, OperationVariables } from '@apollo/client';
import { fetchIsWhatsAppInfobipLocaleUsed } from 'api/queries';

import { DocumentNode } from 'graphql';
import { useGraphql } from 'utils/hooks/useGraphql';

export type FetchCampaignByIdQueryRequest = {
  campaignId: number;
};

export type useIsWhatsAppInfobipLocaleUsed = {
  errorMessage?: ApolloError;
  hasError: boolean;
  isLoading: boolean;
  result: boolean | undefined;
  refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<ApolloQueryResult<any>>;
};

export function useIsWhatsAppInfobipLocaleUsed(
  options: Record<string, any> = {},
  query: DocumentNode = fetchIsWhatsAppInfobipLocaleUsed,
): useIsWhatsAppInfobipLocaleUsed {
  const queryOptions = {
    notifyOnNetworkStatusChange: true,
    ...options,
  };

  const {
    data,
    errorMessage,
    isLoading,
    error: hasError = false,
    refetch,
  } = useGraphql(query, queryOptions);

  const result = data?.isWhatsAppInfobipLocaleUsed ?? undefined;

  return {
    refetch,
    errorMessage,
    hasError,
    isLoading,
    result,
  };
}
